const e = {
  name: "Bank",
  dimensions: { width: 24, height: 24 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3861 2.21065C11.7472 1.92978 12.2529 1.92978 12.614 2.21065L21.614 9.21065C21.9512 9.47293 22.0846 9.92046 21.9459 10.3245C21.8073 10.7286 21.4273 11 21.0001 11H19V20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H5V11H3.00006C2.57286 11 2.19283 10.7286 2.05419 10.3245C1.91554 9.92046 2.0489 9.47293 2.38612 9.21065L11.3861 2.21065ZM7 20H9V11H7V20ZM11 20H13V11H11V20ZM15 20H17V11H15V20ZM18.0855 9H5.9146L12.0001 4.26686L18.0855 9Z" fill="currentColor"/>
    `
};
export {
  e as Bank
};
